import { render, staticRenderFns } from "./AmountSlidingDoor.vue?vue&type=template&id=504de710&"
import script from "./AmountSlidingDoor.vue?vue&type=script&lang=ts&"
export * from "./AmountSlidingDoor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports